var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ClientOnly',[(_vm.getCmsData)?_c('v-runtime-template',{class:['cms-block-content', { container: _vm.sync }],attrs:{"template":"<div>" + _vm.getCmsData.content + "</div>"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }